import { render, staticRenderFns } from "./ActivityLog.vue?vue&type=template&id=5b4c99b2"
import script from "./ActivityLog.vue?vue&type=script&lang=js"
export * from "./ActivityLog.vue?vue&type=script&lang=js"
import style0 from "./ActivityLog.vue?vue&type=style&index=0&id=5b4c99b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports